import _ from "lodash";
import { IRootState } from "../../types/redux/IRootStore";
import { ReduxStateAuthAplParameter } from "../../types/redux/reduxStateAuthAplParameter";
import { isUsSite } from "../../aplUtils/sitesHelper";
import { UserPermission } from "../../types/userPermission";
import { userHasPermissionAnyLine, userHasPermissionByDepartmentId, userHasPermissionByLineId } from "../../aplUtils/permissions";
import { AplParameter } from "../../types/aplParameter";

const filterParams = (params: ReduxStateAuthAplParameter[], siteId: number): ReduxStateAuthAplParameter[] => {
    let results: ReduxStateAuthAplParameter[] = [];
    let types = _.uniq(params.map(x => x.aplParameterType));
    for (let i = 0; i < types.length; i++) {
        let defined = params.find(x => x.confusingSiteId === siteId && x.aplParameterType === types[i]);
        if (defined) {
            results.push(defined);
            continue;
        } else {
            let def = params.find(x => x.confusingSiteId === -1 && x.aplParameterType === types[i]);
            if (def) {
                results.push(def);
                continue;
            }
        }
    }
    return results;
};

const aplSettingsFromState = (state: IRootState) => {
    const auth = state.auth;
    const sites = auth.sites;
    const siteId = sites === undefined || sites.length === 0 ? 0 : _.find(sites, x => x.selected)?.siteId ?? sites[0].siteId;

    const departments = Array.isArray(state.auth.departments) ? state.auth.departments.filter(x => x.siteId === siteId) : [];

    const departmentId = _.find(departments, x => x.siteId === siteId && x.selected)?.departmentId ?? 0;

    const permissions = state.auth.userLinePermissions;
    const permsSets = state.auth.userLinePermissionsSet;

    const activity = state.activity;
    const culture = state.auth.culture;
    const authLoading = state.auth.loading;

    const onlinePrinters = state.labelling.activities?.[0]?.printers ?? [];
    const offlinePrinters = state.labelling.offlinePrinters ?? [];
    const allprinters = [...onlinePrinters, ...offlinePrinters];
    const siteParams = filterParams(auth.aplParameters, siteId);

    const selectedSite = sites.find(x => x.selected);
    const usSite = selectedSite != null && isUsSite(selectedSite);

    const hasPermAnyLine = (permission: UserPermission) => userHasPermissionAnyLine(permsSets, permission);
    const hasPermByLineId = (permission: UserPermission, lineId: number) => userHasPermissionByLineId(permsSets, permission, lineId);
    const hasPermCurrentDepartment = (permission: UserPermission) => userHasPermissionByDepartmentId(permsSets, permission, departmentId);

    const getParam = (type: AplParameter) => siteParams.find(x => x.aplParameterType === type)?.value ?? "";

    let returnObj = {
        sites: sites,
        lines: state.auth.lines,
        siteId: siteId,
        site: _.find(sites, x => x.siteId === siteId) ?? sites[0],
        departments: departments,
        departmentId: departmentId,
        activity: activity,
        culture: culture,
        userName: auth.userName,
        userId: auth.userId,
        onlinePrinters: onlinePrinters,
        offlinePrinters: offlinePrinters,
        allprinters: allprinters,
        permissions: permissions,
        permsSets: permsSets,
        authLoading: authLoading,
        siteParams: siteParams,
        isUsSite: usSite,
        theme: auth.theme,
        hasPermAnyLine: hasPermAnyLine,
        hasPermByLineId: hasPermByLineId,
        hasPermCurrentDepartment: hasPermCurrentDepartment,
        getParam: getParam,
    };

    return returnObj;
};

export type IAplSettings = ReturnType<typeof aplSettingsFromState>;

export {aplSettingsFromState};
